__turbopack_context__.v({
  "active": "style-module-scss-module__vQkTxG__active",
  "component": "style-module-scss-module__vQkTxG__component",
});
